import React from "react";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Rajesh Mehta",
    role: "Managing Director, Mehta Realty",
    text:
      "Pravin Gupta & Associates guided our society through a complex redevelopment deal with clarity and precision. Their attention to detail is exceptional.",
    initial: "RM",
  },
  {
    name: "Sunita Kapoor",
    role: "Individual Client",
    text:
      "Handled my matrimonial case with immense sensitivity and got the outcome I hoped for. Truly a firm you can trust.",
    initial: "SK",
  },
  {
    name: "Amit Bansal",
    role: "Founder, NextGen Technologies",
    text:
      "From incorporation to IP protection to commercial contracts - they have been a one-stop legal partner for my startup.",
    initial: "AB",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-[#f7f2e8]/50">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[#b28e42] uppercase tracking-[0.35em] text-xs font-semibold">Testimonials</span>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#0e1b34] mt-3 gold-underline center">
            What Our Clients Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-sm p-8 border border-neutral-200 hover:border-[#c9a961] transition-colors relative">
              <Quote className="absolute top-6 right-6 text-[#c9a961]/25" size={40} />
              <p className="text-neutral-700 leading-relaxed italic mb-6">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-5 border-t border-neutral-100">
                <div className="w-12 h-12 rounded-full bg-[#0e1b34] text-[#c9a961] flex items-center justify-center font-semibold">
                  {t.initial}
                </div>
                <div>
                  <div className="font-serif-display text-[#0e1b34] font-semibold">{t.name}</div>
                  <div className="text-xs text-neutral-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
